"use client";

import { formSlugs } from "@/helpers/utils/form-constants";
import { FILM_FESTIVAL_DATES, filmFormLinks } from "@/helpers/utils/film-constants";
import { getFormCycle, getCycleOpensOn, isCycleOpen } from "./form-cycles";

// /form/film used to be a single filmmaker form. It now points people to the
// three C-Tribe x Film forms. Legacy responses stay in Firestore untouched.
const choices = [
  {
    slug: formSlugs.filmSubmission, href: filmFormLinks.submission, title: "Submit a film for screening",
    body: "Features, shorts, documentaries, episodic work, animation, experimental work and music videos. There is no entry fee.",
  },
  {
    slug: formSlugs.filmPitch, href: filmFormLinks.pitch, title: "Apply for pitch meetings",
    body: "One-on-one meetings with distributors, sales agents, producers and funders, for a finished film or a project in development.",
  },
  {
    slug: formSlugs.filmIndustry, href: filmFormLinks.industry, title: "Industry registration",
    body: "For distributors, sales agents, producers, broadcasters, streamers, funders, agents and programmers who want to meet filmmakers.",
  },
] as const;

function availability(slug: string, now: Date): string {
  const cycle = getFormCycle(slug);
  if (!cycle) return "Closed";
  const opensOn = getCycleOpensOn(cycle, now);
  if (opensOn) return `Opens ${opensOn}`;
  return isCycleOpen(cycle, now) ? "Open now" : "Closed";
}

export default function FilmFormChooser({ now = new Date() }: { now?: Date }) {
  return (
    <div className="formLayout-background-container">
      <div className="loginLayout-content">
        <div className="overflow-y-auto flex items-center justify-center min-h-screen w-full px-4 py-12">
          <main className="flex flex-col w-full max-w-[38.938rem] p-6 md:p-10 shadow-2xl rounded-2xl bg-white bg-opacity-90 text-custom-gray">
            <h1 className="text-2xl font-semibold text-center">C-Tribe x Film 2027: choose your application</h1>
            <p className="text-base text-center mt-4">
              C-Tribe x Film runs {FILM_FESTIVAL_DATES} in Edmonton. Pick the form that fits you.
            </p>
            <ul className="mt-6 flex flex-col gap-4">
              {choices.map((choice) => (
                <li key={choice.slug}>
                  <a href={choice.href} className="block rounded-xl border border-gray-300 bg-white p-4 hover:border-black focus:outline-none focus-visible:ring-2 focus-visible:ring-black">
                    <span className="block text-lg font-semibold text-black">{choice.title}</span>
                    <span className="block text-sm mt-1">{choice.body}</span>
                    <span className="block text-sm font-medium mt-2">{availability(choice.slug, now)}</span>
                  </a>
                </li>
              ))}
            </ul>
            <p className="text-sm text-center mt-6">
              Applied through our earlier film form? We still have your submission. Questions? Email{" "}
              <a href="mailto:hello@ctribefestival.com" className="underline font-medium">hello@ctribefestival.com</a>.
            </p>
          </main>
        </div>
      </div>
    </div>
  );
}
